<template>
  <manual-page
    title="Gestion de Usuarios"
    description="Administra los usuarios de tu franquicia y configura roles y permisos."
    :show-video="true"
    :related-links="relatedLinks"
    :action-route="{ name: 'usersIndex' }"
    action-text="Ir a Usuarios"
  >
    <h2>Lista de Usuarios</h2>
    <p>La lista de usuarios muestra:</p>
    <ul>
      <li><strong>Nombre</strong> del usuario</li>
      <li><strong>Email</strong> de acceso</li>
      <li><strong>Rol</strong> asignado</li>
      <li><strong>Estado:</strong> Activo o inactivo</li>
      <li><strong>Sucursales:</strong> A cuales tiene acceso</li>
    </ul>

    <div class="tip-box">
      <p><strong>Tip:</strong> Haz clic en un usuario para ver su detalle y opciones.</p>
    </div>

    <h2>Crear Usuario</h2>
    <p>Para crear un nuevo usuario:</p>

    <div class="step-card">
      <span class="step-number">1</span>
      Ve a <strong>Usuarios</strong> y haz clic en "Crear"
    </div>

    <div class="step-card">
      <span class="step-number">2</span>
      Ingresa los datos:
      <ul>
        <li>Nombre completo</li>
        <li>Email (sera su usuario de acceso)</li>
        <li>Contrasena temporal</li>
      </ul>
    </div>

    <div class="step-card">
      <span class="step-number">3</span>
      Selecciona el rol que tendra
    </div>

    <div class="step-card">
      <span class="step-number">4</span>
      Indica las sucursales a las que tendra acceso
    </div>

    <div class="step-card">
      <span class="step-number">5</span>
      Guarda el usuario
    </div>

    <div class="info-box">
      <p>El nuevo usuario recibira un email con sus credenciales de acceso.</p>
    </div>

    <h2>Editar Usuario</h2>
    <p>Para editar un usuario:</p>

    <div class="step-card">
      <span class="step-number">1</span>
      Encuentra al usuario en la lista
    </div>

    <div class="step-card">
      <span class="step-number">2</span>
      Haz clic para ver su detalle
    </div>

    <div class="step-card">
      <span class="step-number">3</span>
      Selecciona "Editar"
    </div>

    <div class="step-card">
      <span class="step-number">4</span>
      Modifica los datos necesarios
    </div>

    <div class="step-card">
      <span class="step-number">5</span>
      Guarda los cambios
    </div>

    <div class="tip-box">
      <p><strong>Tip:</strong> Puedes cambiar rol, sucursales y restablecer contrasena.</p>
    </div>

    <h2>Roles y Permisos</h2>

    <h3>Ver Roles</h3>
    <p>Los roles disponibles incluyen:</p>
    <ul>
      <li><strong>Administrador:</strong> Acceso total a todas las funciones</li>
      <li><strong>Operador:</strong> Gestion de ordenes y produccion</li>
      <li><strong>Contador:</strong> Acceso a contabilidad y reportes</li>
      <li><strong>Personalizado:</strong> Roles creados por ti</li>
    </ul>

    <div class="info-box">
      <p>Cada rol define que puede ver y hacer un usuario.</p>
    </div>

    <h3>Crear Rol</h3>
    <p>Para crear un rol personalizado:</p>

    <div class="step-card">
      <span class="step-number">1</span>
      Ve a <strong>Roles</strong> y haz clic en "Crear"
    </div>

    <div class="step-card">
      <span class="step-number">2</span>
      Asigna un nombre descriptivo
    </div>

    <div class="step-card">
      <span class="step-number">3</span>
      Selecciona los permisos:
      <ul>
        <li>Ver/Editar ordenes</li>
        <li>Ver/Editar clientes</li>
        <li>Ver/Editar inventario</li>
        <li>Ver/Editar contabilidad</li>
        <li>Etc.</li>
      </ul>
    </div>

    <div class="step-card">
      <span class="step-number">4</span>
      Guarda el rol
    </div>

    <div class="info-box">
      <p>Los usuarios con este rol tendran solo los permisos seleccionados.</p>
    </div>

    <h3>Permisos</h3>
    <p>Tipos de permisos:</p>
    <ul>
      <li><strong>Ver (view):</strong> Puede consultar informacion</li>
      <li><strong>Editar (edit):</strong> Puede crear y modificar</li>
      <li><strong>Eliminar (delete):</strong> Puede borrar registros</li>
    </ul>

    <p>Areas de permisos:</p>
    <ul>
      <li>Ordenes, Clientes, Mascotas</li>
      <li>Inventario, Productos</li>
      <li>Usuarios, Roles</li>
      <li>Contabilidad, Reportes</li>
    </ul>

    <div class="warning-box">
      <p><strong>Importante:</strong> Asigna solo los permisos necesarios para cada funcion.</p>
    </div>
  </manual-page>
</template>

<script>
import ManualPage from "@/components/manual/ManualPage.vue";

export default {
  name: "ManualUsers",
  components: { ManualPage },
  data() {
    return {
      relatedLinks: [
        { route: "manualGettingStarted", label: "Primeros Pasos" },
        { route: "manualReports", label: "Reportes" },
        { route: "manualAccounting", label: "Contabilidad" },
      ],
    };
  },
};
</script>
